import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
export function DespreOffers() {
  return <section className="py-20 lg:py-32 bg-white relative overflow-hidden" data-id="element-1227">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-brand-gold/10 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-1228" />
      <div className="absolute bottom-0 left-0 w-[350px] h-[350px] bg-brand-purple/10 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-1229" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-1230">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-brand-cream to-white rounded-3xl border border-brand-gold/20 shadow-warm p-10 lg:p-16 text-center" data-id="element-1231">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-brand-gold/15 text-brand-gold mb-6" data-id="element-1232">
            <Sparkles className="w-8 h-8" data-id="element-1233" />
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-brand-text mb-5 leading-tight" data-id="element-1234">
            Descoperă programele mele
          </h2>

          <p className="font-subtitle text-lg md:text-xl text-brand-textSec leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-1235">
            Explorează toate cursurile online disponibile și alege programul
            care ți se potrivește pentru călătoria ta spre abundență.
          </p>

          <a href="https://academiadeabundenta.ro/magazin" target="_top" className="group inline-flex items-center justify-center gap-3 bg-brand-gold text-white font-heading font-bold text-lg px-9 py-5 rounded-2xl hover:bg-brand-purple transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1" data-id="element-1236">
            Vreau să descopăr cursurile online
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1237" />
          </a>
        </motion.div>
      </div>
    </section>;
}